import push from '../../utils/routing';

type QueryParams = Record<string, string | number | boolean | null | undefined>;

export default (spaceId: string, queryParams?: QueryParams) => () => {
  let basePath = `/dashboard/${spaceId}/journey/materials`;
  const isMobileScreen = window.matchMedia('(max-width: 899px)').matches;
  if (isMobileScreen) {
    basePath = `${basePath}/material-list`;
  }

  if (!queryParams) {
    push(basePath);
    return;
  }

  const params = new URLSearchParams(
    Object.entries(queryParams)
      .filter(([, value]) => value != null)
      .map(([key, value]) => [key, String(value)] as [string, string])
  );
  const updatedPath = params.toString() ? `${basePath}?${params}` : basePath;
  push(updatedPath);
};
